import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'
import { RoutePath } from '../layout/Routes'

import { OrganisationProfile, useOrganisationProfile } from '@percent/domain/organisation-profile'
import { useCountries } from '@percent/partner-dashboard/common/hooks/useCountries/useCountries'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

function OrganisationProfileBreadcrumbs({ organisationId }: Readonly<{ organisationId: string }>) {
  const { t } = useTranslation()
  const { data } = useOrganisationProfile(organisationId)

  useBreadcrumbs([
    {
      label: t('breadcrumb.organisations'),
      path: RoutePath.ORGANISATIONS
    },
    {
      label: data?.organisation.displayName || data?.organisation.name || ''
    }
  ])

  return null
}

export function OrganisationProfileContainer() {
  const { organisationId = '' } = useParams<{ organisationId: string }>()
  const { i18n } = useTranslation()
  const { organisationProfileService } = useServices()
  const { countries } = useCountries()

  return (
    <OrganisationProfile.Provider
      service={organisationProfileService}
      locale={i18n.language}
      countries={countries ?? undefined}
    >
      <OrganisationProfileBreadcrumbs organisationId={organisationId} />
      <OrganisationProfile.ProfilePage organisationId={organisationId} />
    </OrganisationProfile.Provider>
  )
}
